import { APICallV3Post } from 'reactApp/api/APICall';
import { CloudActions } from 'reactApp/constants/cloudActions';

export class DownloadZipV3APICall extends APICallV3Post {
    _method = 'zip';
    _headers = { 'X-VFS-Action': CloudActions.LIST_DOWNLOAD };
}
